import {
  QBankStructureLevelCategory,
  type QBankStructureLevelItemWithLevel,
} from '@exam-management/qbs-provider';

export function getQuestionSourceForLOS(
  structureCode: number,
  levelItems: QBankStructureLevelItemWithLevel[],
  chapterId: string,
) {
  const maxLevel = 5;
  const availableLevelCategories = [
    QBankStructureLevelCategory.Part,
    QBankStructureLevelCategory.Group,
    QBankStructureLevelCategory.Subject,
    QBankStructureLevelCategory.Chapter,
  ];

  const filteredLevelItems = levelItems.filter((levelItem) =>
    availableLevelCategories.includes(levelItem.qBankStructureLevel.category),
  );
  const levelItemMap = new Map(filteredLevelItems.map((item) => [item.id, item]));

  // prefilled qSource
  // Example: '1-x-x-x-x'
  const qSource: (number | string)[] = [structureCode, ...Array(maxLevel - 1).fill('x')];

  let currentItem = levelItemMap.get(chapterId);

  while (currentItem) {
    qSource[currentItem.qBankStructureLevel.level - 1] = currentItem.order;
    currentItem = currentItem.parentLevelItemId
      ? levelItemMap.get(currentItem.parentLevelItemId)
      : undefined;
  }

  return qSource.join('-');
}
